<template lang='pug'>
  el-card
    div(slot="header")
      span(style="font-size:20px;font-weight:bold") 会谈问题
        el-button(style="float: right; padding: 3px 0" type="text" @click="handleCreateTpl()") 新增模板
    el-collapse(v-model="activeNames" accordion @change="loadQus")
      el-collapse-item(v-for="tpl,k in data" :title="'【'+tpl.type+(tpl.mokuai?' '+tpl.mokuai:'')+'】'+tpl.name" :name="k+1" :key="k")
        div.tpl-actions(style="text-align:right")
          el-button(type="text" @click="handleCreateQus(tpl)") 新增问题
          el-button(type="text" @click="handleEditTpl(tpl)") 修改模板
          el-button(type="text" @click="handleDeleteTpl(tpl)") 删除模板
        el-table(v-if="tpl.questions" :data="tpl.questions" style="width: 100%")
          el-table-column(prop="order" label="序号" width="70" align="center")
          el-table-column(prop="name" label="问题" width="350" show-overflow-tooltip)
          el-table-column(prop="type" label="类型" width="70")
          el-table-column(label="选项" width="300")
            template(slot-scope="scope")
              template(v-if="scope.row.options" show-overflow-tooltip)
                template(v-for="opt in scope.row.options") {{opt.text}};
              template(v-else) 无
          el-table-column(prop="upField" label="对应列" width="100")
          el-table-column(prop="upMethod" label="更新方式" width="100")
          el-table-column(label="尾部文本框" width="120")
            template(slot-scope="scope")
              span(v-if="scope.row.hasText") 是
              span(v-else) 否
          el-table-column(prop="textField" label="文本框对应列" width="130")
          el-table-column(label="包含话术" width="100")
            template(slot-scope="scope")
              span(v-if="scope.row.hasHuashu") 是
              span(v-else) 否
          el-table-column(label="每个SL答案不同" width="140")
            template(slot-scope="scope")
              span(v-if="scope.row.isDiffInPro") 是
              span(v-else) 否
          el-table-column(label="必填")
            template(slot-scope="scope")
              span(v-if="scope.row.isRequired") 是
              span(v-else) 否
          el-table-column(fixed="right" label="操作" width="100")
            template(slot-scope="scope")
              el-button(@click="handleEditQus(scope.row)" type="text" size="small") 修改
              el-button(@click="handleDeleteQus(scope.row)" type="text" size="small") 删除
    el-dialog(:title="dialogTplTitle" :visible.sync="dialogTplVisible" :before-close="closeTpl")
      el-form(:model="tplForm")
        input(type="hidden" v-model="tplForm._id")
        el-form-item(label="*模板名称" label-width="80px")
          el-input(v-model="tplForm.name")
        el-form-item(label="*模板类型" label-width="80px")
          el-select(v-model="tplForm.type")
            el-option(v-for="tt,k in template_types" :label="tt" :value="tt" :key="k")
        el-form-item(v-show="tplForm.type=='职能模块'" label="*职能模块" label-width="80px")
          el-autocomplete(v-model="tplForm.mokuai" :fetch-suggestions="fetchSuggestions")
      div(slot="footer" class="dialog-footer")
        el-button(@click="closeTpl()") 取 消
        el-button(type="primary" @click="handleSaveTpl()") 确 定
    el-dialog(:title="dialogQusTitle" :visible.sync="dialogQusVisible" :before-close="closeQus")
      el-form(:model="qusForm")
        el-form-item(label="*问题描述" label-width="100px")
          el-input(v-model="qusForm.name")
        el-form-item(label="*问题类型" label-width="100px")
          el-select(v-model="qusForm.type")
            el-option(v-for="qt,k in question_types" :label="qt" :value="qt" :key="k")
        el-form-item(label="序号" label-width="100px")
          el-input-number(v-model="qusForm.order" :min="1" :max="100")
        el-form-item(label="对应列" label-width="100px")
          el-select(v-model="qusForm.upField")
            el-option(v-for="ft,k in field_types" :label="ft" :value="ft" :key="k")
        el-form-item(label="列更新方式" label-width="100px")
          el-select(v-model="qusForm.upMethod")
            el-option(v-for="ut,k in up_method_types" :label="ut" :value="ut" :key="k")
        el-form-item(label="尾部文本框" label-width="100px")
          el-switch(v-model="qusForm.hasText")
        el-form-item(v-show="qusForm.hasText" label="*文本框对应列" label-width="110px")
          el-select(v-model="qusForm.textField")
            el-option(v-for="ft,k in field_types" :label="ft" :value="ft" :key="k")
        el-form-item(label='包含话术(描述中需有"[huashu]"占位)' label-width="250px")
          el-switch(v-model="qusForm.hasHuashu")
        el-form-item(label="每个SL答案不同" label-width="120px")
          el-switch(v-model="qusForm.isDiffInPro")
        el-form-item(label="必填" label-width="100px")
          el-switch(v-model="qusForm.isRequired")
        el-form-item 选项：
          el-button(@click="handleCreateOpt()" type="text" size="small" style="margin-left:5px") 添加选项
          span （选项全部添加或修改完毕后按确定保存）
          el-table(v-if="qusForm.options" :data="qusForm.options" style="width: 100%")
            el-table-column(prop="order" label="序号" width="70" align="center")
            el-table-column(prop="text" label="选项文字" width="100")
            el-table-column(prop="value" label="选项值")
            el-table-column(prop="action" label="动作" width="70")
            el-table-column(prop="upField" label="对应列" width="100")
            el-table-column(label="弹框")
              template(slot-scope="scope")
                span(v-if="scope.row.hasAlert") 是
                span(v-else) 否
            el-table-column(prop="alertContent" label="弹框内容" width="200")
            el-table-column(prop="alertBottom" label="弹框底部内容" width="150")
            el-table-column(fixed="right" label="操作" width="100")
              template(slot-scope="scope")
                el-button(@click="handleEditOpt(scope.row, scope.$index)" type="text" size="small") 修改
                el-button(@click="handleDeleteOpt(scope.$index)" type="text" size="small") 删除
      div(slot="footer" class="dialog-footer")
        el-button(@click="closeQus()") 取 消
        el-button(type="primary" @click="handleSaveQus()") 确 定
    el-dialog(:title="dialogOptTitle" :visible.sync="dialogOptVisible" :before-close="closeOpt")
      el-form(:model="optForm")
        el-form-item(label="*选项文字" label-width="80px")
          el-input(v-model="optForm.text")
        el-form-item(label="*选项值" label-width="80px")
          el-input(v-model="optForm.value" style="width:225px;")
        el-form-item(label="序号" label-width="80px")
          el-input-number(v-model="optForm.order" :min="1" :max="100")
        el-form-item(label="动作" label-width="80px")
          el-select(v-model="optForm.action")
            el-option(v-for="at,k in action_types" :label="at" :value="at" :key="k")
        el-form-item(label="对应列" label-width="80px")
          el-select(v-model="optForm.upField")
            el-option(v-for="ft,k in field_types" :label="ft" :value="ft" :key="k")
        el-form-item(label="弹框" label-width="80px")
          el-switch(v-model="optForm.hasAlert")
        el-form-item(v-show="optForm.hasAlert" label="弹框内容" label-width="80px")
          el-input(v-model="optForm.alertContent" style="width:225px;")
        el-form-item(v-show="optForm.hasAlert" label="弹框底部内容" label-width="100px")
          el-input(v-model="optForm.alertBottom" style="width:225px;")
      div(slot="footer" class="dialog-footer")
        el-button(@click="closeOpt()") 取 消
        el-button(type="primary" @click="handleSaveOpt()") 确 定

</template>

<script>
// Generated by CoffeeScript 2.3.0
var m, suggestions;

suggestions = [];

export default m = {
  data: function() {
    return {
      activeNames: 1,
      template_types: ['通用', '职能模块', '项目', '其他'],
      question_types: ['单选', '多选', '填空'],
      up_method_types: ['覆盖', '添加'],
      action_types: ['标注', '提醒', '标签'],
      field_types: ['意向', '长期意向', '规模', '管理基金数量', '管理基金', '任职期', '行业', '职能模块', '平台', '职能', '职级', '业绩', '擅长方向', '个性标签', '姓名', '手机', '公司', '公司变动', '部门', '目前职位', '沟通备注', '管理职级', '团队人数', '汇报上级', '专业职级', '思维分析', '沟通影响', '人际理解', '学习开放', '目标导向', '执行抗压', '地域', '固薪', '奖金', '薪酬机制', '简介', '性别', '婚育', '出生年月', '毕业院校', '曾任职公司', '到现公司时间', '从业起始年份', '部门概况', '标签', '微信', '座机', '邮箱', '文化风格', '成就动机', '人选诉求'],
      dialogTplVisible: false,
      dialogTplTitle: '模板',
      tplForm: {},
      dialogQusVisible: false,
      dialogQusTitle: '问题',
      qusForm: {},
      dialogOptVisible: false,
      dialogOptTitle: '选项',
      optForm: {},
      editingOptRow: -1,
      data: []
    };
  },
  // data: [
  //   _id: '1'
  //   name: '模板1'
  //   type: '通用'
  //   questions: [
  //     _id: '1'
  //     order: 1
  //     name: '你的职能'
  //     type: '单选'
  //     upField: '职能'
  //     upMethod: '覆盖'
  //     hasText: true
  //     textField: null
  //     hasHuashu: false
  //     isDiffInPro: false
  //     isRequired: true
  //     options: [
  //       _id: '1'
  //       text: '承揽'
  //       value: '1)'
  //       action: null
  //       hasAlert: false
  //       alertContent: ''
  //       upField: null
  //     ]
  //   ]
  // ]
  methods: {
    cutString: function(str) {
      var short;
      short = str.substring(0, 10);
      if (short.length < str.length) {
        short = short + '...';
      }
      return short;
    },
    handleCreateTpl: function() {
      this.dialogTplTitle = '新增模板';
      return this.dialogTplVisible = true;
    },
    handleEditTpl: function(tpl) {
      this.dialogTplTitle = '编辑模板-' + tpl.name;
      this.tplForm = tpl;
      return this.dialogTplVisible = true;
    },
    handleSaveTpl: function() {
      var tplForm;
      if (!this.tplForm.name) {
        this.$message({
          type: 'warning',
          message: '请填写模板名称'
        });
        return false;
      }
      if (!this.tplForm.type) {
        this.$message({
          type: 'warning',
          message: '请选择模板类型'
        });
        return false;
      }
      tplForm = this.tplForm;
      if (this.tplForm._id) {
        app.api.update({
          tableName: 'templates',
          _id: this.tplForm._id,
          data: this.tplForm
        }).then((res) => {
          return this.data = this.data.map((dt) => {
            if (dt._id === tplForm._id) {
              return tplForm;
            } else {
              return dt;
            }
          });
        });
      } else {
        app.api.create({
          tableName: 'templates',
          data: {
            name: this.tplForm.name,
            type: this.tplForm.type,
            permissions: {
              "所有人": "读写"
            }
          }
        }).then((res) => {
          return this.data.unshift(res);
        });
      }
      return this.closeTpl();
    },
    handleDeleteTpl: function(tpl) {
      return this.$confirm('确认删除模板【' + tpl.name + '】吗？').then(() => {
        if (tpl._id) {
          return app.api.delete({
            tableName: 'templates',
            _id: tpl._id
          });
        }
      }).then((res) => {
        if (tpl.questions) {
          tpl.questions.map((qus) => {
            return app.api.delete({
              tableName: 'questions',
              _id: qus._id
            });
          });
        }
        return this.data = this.data.filter((dt) => {
          return dt._id !== tpl._id;
        });
      }).catch(() => {});
    },
    closeTpl: function() {
      this.tplForm = {};
      return this.dialogTplVisible = false;
    },
    handleCreateQus: function(tpl) {
      this.dialogTplTitle = '新增问题-' + tpl.name;
      this.qusForm.tid = tpl._id;
      return this.dialogQusVisible = true;
    },
    handleEditQus: function(qus) {
      this.dialogQusTitle = '编辑问题';
      this.qusForm = qus;
      return this.dialogQusVisible = true;
    },
    handleSaveQus: function() {
      var data, qusForm;
      if (!this.qusForm.name) {
        this.$message({
          type: 'warning',
          message: '请填写问题描述'
        });
        return false;
      }
      if (!this.qusForm.type) {
        this.$message({
          type: 'warning',
          message: '请选择问题类型'
        });
        return false;
      }
      if (this.qusForm.type !== '填空' && !this.qusForm.options) {
        this.$message({
          type: 'warning',
          message: '请至少添加一个选项'
        });
        return false;
      }
      qusForm = this.qusForm;
      // console.log 'savequs'
      // console.log qusForm
      if (this.qusForm._id) {
        app.api.update({
          tableName: 'questions',
          _id: this.qusForm._id,
          data: this.qusForm
        }).then((res) => {
          // console.log res
          return this.data = this.data.map((dt) => {
            if (dt._id === qusForm.tid) {
              dt.questions = dt.questions.map((q) => {
                if (q._id === qusForm._id) {
                  return qusForm;
                } else {
                  return q;
                }
              });
            }
            return dt;
          });
        });
      } else {
        data = qusForm;
        data.permissions = {
          "所有人": "读写"
        };
        app.api.create({
          tableName: 'questions',
          data: data
        }).then((res) => {
          return this.data = this.data.map((dt) => {
            if (dt._id === qusForm.tid) {
              if (dt.questions == null) {
                dt.questions = [];
              }
              dt.questions.unshift(qusForm);
              dt.questions = dt.questions.sort((a, b) => {
                return a.order - b.order;
              });
            }
            return dt;
          });
        });
      }
      return this.closeQus();
    },
    handleDeleteQus: function(qus) {
      var short;
      short = this.cutString(qus.name);
      return this.$confirm('确认删除问题【' + short + '】吗？').then(() => {
        if (qus._id) {
          return app.api.delete({
            tableName: 'questions',
            _id: qus._id
          });
        }
      }).then((res) => {
        return this.data = this.data.map((dt) => {
          if (dt._id === qus.tid) {
            dt.questions = dt.questions.filter((q) => {
              return q._id !== qus._id;
            });
          }
          return dt;
        });
      }).catch(() => {});
    },
    closeQus: function() {
      this.qusForm = {};
      return this.dialogQusVisible = false;
    },
    handleCreateOpt: function() {
      if (!this.qusForm.type) {
        this.$message({
          type: 'warning',
          message: '请选择问题类型'
        });
        return false;
      }
      if (this.qusForm.type === '填空') {
        this.$message({
          type: 'warning',
          message: '填空类型不能添加选项'
        });
        return false;
      }
      this.dialogOptTitle = '新增选项';
      return this.dialogOptVisible = true;
    },
    handleEditOpt: function(opt, row) {
      this.dialogOptTitle = '编辑选项';
      this.optForm = opt;
      this.editingOptRow = row;
      return this.dialogOptVisible = true;
    },
    handleSaveOpt: function() {
      var base;
      if (!this.optForm.text) {
        this.$message({
          type: 'warning',
          message: '请填写选项文字'
        });
        return false;
      }
      if (!this.optForm.value) {
        this.$message({
          type: 'warning',
          message: '请填写选项值'
        });
        return false;
      }
      if ((base = this.qusForm).options == null) {
        base.options = [];
      }
      if (this.editingOptRow > -1) {
        this.qusForm.options.splice(this.editingOptRow, 1, this.optForm);
      } else {
        this.qusForm.options.push(this.optForm);
      }
      this.qusForm.options = this.qusForm.options.sort((a, b) => {
        return a.order - b.order;
      });
      return this.closeOpt();
    },
    handleDeleteOpt: function(row) {
      return this.qusForm.options.splice(row, 1);
    },
    closeOpt: function() {
      this.optForm = {};
      this.editingOptRow = -1;
      return this.dialogOptVisible = false;
    },
    loadData: function() {
      return app.api.find({
        tableName: 'templates'
      }).then((tpls) => {
        if (tpls.length > 0) {
          this.data = tpls;
          return this.loadQus(1);
        }
      });
    },
    loadQus: function(activeNames) {
      var dt, tid;
      // console.log 'loadqus'
      // console.log @data
      if (activeNames) {
        dt = this.data[activeNames - 1];
        // console.log dt
        // if !dt.questions
        tid = dt._id;
        // console.log tid
        return app.api.find({
          tableName: 'questions',
          query: {
            tid: tid
          },
          $sort: {
            order: 1
          }
        }).then((qus) => {
          // console.log qus
          if (qus.length > 0) {
            return this.data = this.data.map((dt) => {
              if (dt._id === tid) {
                dt.questions = qus;
              }
              return dt;
            });
          }
        });
      }
    },
    fetchSuggestions: function(qs, cb) {
      var s;
      s = [];
      return Promise.resolve().then(() => {
        if (suggestions.length > 0) {
          return s = suggestions;
        } else {
          return app.api.find({
            tableName: 'categories',
            fields: {
              '名称': 1
            }
          }).then((list) => {
            return s = suggestions = list.map((item) => {
              return {
                value: item['名称']
              };
            });
          });
        }
      }).then(() => {
        if (qs) {
          return cb(s.filter((c) => {
            return c.value && c.value.toUpperCase().indexOf(qs.toUpperCase()) !== -1;
          }));
        } else {
          return cb(s);
        }
      });
    }
  },
  created: function() {
    return this.loadData();
  }
};
</script>

